import { render, staticRenderFns } from "./VerInforme.vue?vue&type=template&id=0748ac89&scoped=true"
import script from "./VerInforme.vue?vue&type=script&lang=js"
export * from "./VerInforme.vue?vue&type=script&lang=js"
import style0 from "./VerInforme.vue?vue&type=style&index=0&id=0748ac89&prod&scoped=true&lang=css"
import style1 from "./VerInforme.vue?vue&type=style&index=1&id=0748ac89&prod&lang=scss&scoped=true"
import style2 from "./VerInforme.vue?vue&type=style&index=2&id=0748ac89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0748ac89",
  null
  
)

export default component.exports